// extracted by mini-css-extract-plugin
export var columnList = "_cg-0";